/**
 * First we will load all of this project's JavaScript dependencies which
 * include Vue and Vue Resource. This gives a great starting point for
 * building robust, powerful web applications using Vue and Laravel.
 */
import router from './router.js'
import utils from './helpers/utilities'
import ThemeSwitcher from './components/ThemeSwitcher'
import Auth from './services/auth'
import BootstrapVue from 'bootstrap-vue'
import vSelect from 'vue-select'

import 'vue-select/dist/vue-select.css';
import axios from "axios";

require('./bootstrap')

Vue.prototype.$utils = utils
Vue.use(BootstrapVue);

Vue.component('v-select', vSelect)

Auth.getCurrentUser()
    .then(function (response) {
        if (response) {
            Vue.prototype.$currentUser = response.user;
        } else {
            Vue.prototype.$currentUser = null;
        }
        const app = new Vue({
            router,

            // Theme Swiching Demo Component (You can remove it if not required)
            components: {
                ThemeSwitcher
            }
        }).$mount('#app');
    });






// WEBPACK FOOTER //
// ./resources/js/app.js